import { createSelector } from '@reduxjs/toolkit';
import * as _ from 'lodash';
import type { ReduxStore } from '../store';
import type { Team as TypesTeam } from '../../types';

export type Team = Omit<TypesTeam, 'teamProjects' | 'teamUsers'>;

export type TeamsById = Record<string, Team>;

const getTeamsBase = (state: ReduxStore) => state.teams;
export const getTeams = createSelector([getTeamsBase], ({ teams }) => teams);
export const getTeamList = createSelector([getTeams], _.values);

export const getStatus = createSelector([getTeamsBase], ({ status }) => status);
export const getTeamUpdatingStatus = createSelector([getTeamsBase], ({ teamUpdatingStatus }) => teamUpdatingStatus);
export const getTeamSelection = createSelector([getTeamsBase], (state) => state.teamSelection);
